export default "query {\n  viewer {\n    playbackSettings {\n      audioLang\n      subtitleLang\n      subtitlesEnabled\n    }\n  }\n}\n";